module.exports = __webpack_public_path__ + "img/cream-uppercut-deluxepomade-100.a80b1ba5.jpg";